import {useEffect, useState} from 'react'
import SharedData from '../../../common/SharedData'
import {getSupplierContractInfo} from '../../core/_requests'
import {IProfileContractModel} from '../../core/_models'
import MyProfileFieldText from '../my-profile/MyProfileFieldText'
import ContractMarginTable from './ContractMarginTable'
import ContractStockTable from './ContractStockTable'
import { useIntl } from 'react-intl'

const ContractInfoDetails = () => {
  const {formatMessage} = useIntl();
  const {currentUser, language} = SharedData()
  const [profileInfo, setProfileInfo] = useState<IProfileContractModel>()
  useEffect(() => {
    const getDate = async () => {
      const {data: data} = await getSupplierContractInfo(currentUser?.token, language)
      const info = data.supplier_contract_info
      setProfileInfo(info)
    }
    getDate()
  }, [])

  return (
    <>
      <div className='card'>
        <div className='card-header pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>{formatMessage({ id: "contract_info" })}</span>
          </h3>
        </div>
        <div className='card-body py-3 pt-10'>
          <div className='row gap-14'>
            <div className='col-sm-12 d-flex flex-column gap-6'>
              {/* Supplier Name */}
              {/* <MyProfileFieldText label={formatMessage({ id: "agreement_type" })} value={profileInfo?.payment_type} /> */}
            </div>
            {profileInfo && (
              <>
                <ContractMarginTable
                  paymentType={profileInfo?.payment_type}
                  margin={profileInfo?.margin}
                />
                <ContractStockTable {...profileInfo} />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ContractInfoDetails
